import { useEffect } from 'react';
import ReactModal2 from 'react-modal2';
import classnames from 'classnames';
import { IconButton } from "../../Button/IconButton/IconButton";
import { Overlay } from "../../Overlay/Overlay/Overlay";
import styles from "./Modal.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultOnClose = function defaultOnClose() {};
export var Modal = function Modal(_ref) {
  var _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? defaultOnClose : _ref$onClose,
    _ref$closeable = _ref.closeable,
    closeable = _ref$closeable === void 0 ? true : _ref$closeable,
    _ref$closeFixed = _ref.closeFixed,
    closeFixed = _ref$closeFixed === void 0 ? true : _ref$closeFixed,
    _ref$closeAttributes = _ref.closeAttributes,
    closeAttributes = _ref$closeAttributes === void 0 ? {} : _ref$closeAttributes,
    children = _ref.children;
  useEffect(function () {
    if (!closeable) {
      document.body.style.overflow = 'hidden';
    }
    return function () {
      document.body.style.overflow = 'initial';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(Overlay, {
    children: /*#__PURE__*/_jsx(ReactModal2, {
      onClose: typeof onClose === 'function' ? onClose : defaultOnClose,
      closeOnEsc: closeable,
      closeOnBackdropClick: closeable,
      backdropClassName: styles.modalBackdrop,
      modalClassName: styles.modal,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.modalAnimation,
        children: /*#__PURE__*/_jsxs("div", {
          className: classnames({
            [styles.modalBody]: !closeFixed
          }),
          children: [closeable && /*#__PURE__*/_jsx("div", {
            className: classnames(styles.modalHeader, {
              [styles.modalHeaderFixed]: closeFixed
            }),
            children: /*#__PURE__*/_jsx(IconButton, {
              "aria-label": "Close",
              onClick: onClose,
              icon: "close",
              size: "20px",
              attributes: closeAttributes
            })
          }), /*#__PURE__*/_jsx("div", {
            className: classnames({
              [styles.modalBody]: closeFixed
            }),
            "data-e2e-name": "modal_body",
            children: children
          })]
        })
      })
    })
  });
};